// Lib
import React from 'react';

// Constants
import { ELEMENT_DEFAULT_WIDTH } from '../../../../common/elements/elementConstants';
import useResizableEditorHeightDecorator, { ResizableEditorHeightProps } from './useResizableEditorHeightDecorator';
import { ImMNElement } from '../../../../common/elements/elementModelTypes';

export const CARD_MIN_WIDTH = ELEMENT_DEFAULT_WIDTH / 2;

export default <T extends ResizableEditorHeightProps>({
        getMinContainerHeight,
        containerPaddingGu = 0,
    }: {
        getMinContainerHeight: (element: ImMNElement, gridSize: number, currentEditorHeight: number) => number;
        containerPaddingGu?: number;
    }) =>
    (DecoratedComponent: React.ComponentType<T>): React.FC<T> => {
        return (props: T) => {
            const resizableEditorProps = useResizableEditorHeightDecorator(
                props,
                getMinContainerHeight,
                containerPaddingGu,
            );
            return <DecoratedComponent {...props} {...resizableEditorProps} />;
        };
    };
